import { motion } from "framer-motion";
import { waLink, WA_MESSAGES } from "@/lib/site";

const StickyCta = () => (
    <motion.div
        data-testid="mobile-sticky-cta"
        initial={{ y: 80 }}
        animate={{ y: 0 }}
        transition={{ delay: 1.8, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-[#050505]/95 p-3 backdrop-blur-md md:hidden"
    >
        <a
            data-testid="sticky-book-vip-btn"
            href={waLink(WA_MESSAGES.hero)}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Opens WhatsApp"
            className="flex w-full items-center justify-center gap-2 rounded-sm bg-gold px-6 py-4 text-[11px] font-bold uppercase tracking-[0.25em] text-ink transition-colors duration-300 active:bg-gold-soft"
        >
            Book VIP on WhatsApp
        </a>
    </motion.div>
);

export default StickyCta;
